<template>
  <div id="birthday" class="data-list-container" v-if="config.gocheckin_feature == 1">
    <!-- <vs-breadcrumb :items="items" class="mb-6"></vs-breadcrumb> -->
    <div class="vx-breadcrumb mb-6">
      <ul class="flex flex-wrap items-center">
        <li class="inline-flex items-end">
          <router-link to="/after-login">
            <feather-icon
              icon="HomeIcon"
              svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary"
            />
          </router-link>
          <span class="breadcrumb-separator mx-2 mr-1">
            <feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" />
          </span>
        </li>
        <li class="inline-flex items-end">
          <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">Birthday</span>
        </li>
      </ul>
    </div>
    <vs-table mutiple :max-items="itemsPerPage" :data="birthdaysList">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between"></div>
      <template slot="thead">
        <vs-th class="text-center">Active</vs-th>
        <vs-th class="center-title">Promotion</vs-th>
        <vs-th class="center-title">Expired Day In</vs-th>
        <vs-th class="center-title">Delivered & Redemp</vs-th>
        <vs-th></vs-th>
      </template>
      <template slot-scope="{data}">
        <tbody>
          <vs-tr
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
            @click.native="editData(tr),updateActiveBirthday(tr)"
            class="shadow-md"
          >
            <vs-td>
              <div v-if="tr.campaign.is_active" class="text-center">
                <feather-icon icon="CheckIcon" svgClasses="w-6 h-6 stroke-current text-success" />
              </div>
              <div v-else class="text-center">
                <feather-icon icon="XIcon" svgClasses="w-6 h-6 stroke-current text-danger" />
              </div>
            </vs-td>
            <vs-td>
              <p
                class="promotion-type font-medium truncate p-0"
                style="color:cornflowerblue"
              >Everyone</p>
              <p class="product-name font-medium truncate">{{ tr.campaign.name }}</p>Discount:
              <div v-if="tr.campaign.logic_type=='percent'">
                <p class="product-name font-medium truncate">
                  <b class="logic-font-size">{{ tr.campaign.logic_value }}%</b>
                </p>
              </div>
              <div v-else-if="tr.campaign.logic_type=='usd'">
                <p class="product-name font-medium truncate">
                  <b class="logic-font-size">${{ tr.campaign.logic_value }}</b>
                </p>
              </div>
              <div v-else>
                <p class="product-name font-medium truncate">
                  <b class="logic-font-size">N/A</b>
                </p>
              </div>
              <vs-row class="flex">
                <feather-icon icon="CalendarIcon" svgClasses="w-4 h-4 stroke-current"></feather-icon>
                <span
                  class="product-name font-medium truncate"
                  style="padding-top:5px;padding-left:5px;"
                >Send {{ tr.birthday_campaign.before_date}} days in advance</span>
              </vs-row>
            </vs-td>
            <vs-td>
              <div v-if="tr.campaign.expired_day_in == 0" class="text-center">On your birthday</div>
              <div v-else class="text-center">{{tr.campaign.expired_day_in}} days</div>
            </vs-td>
            <vs-td>
              <vs-row>
                <vs-col class="px-2" vs-w="6">
                  <span class="text-uppercase custom-font-size-title">TOTAL DELIVERED</span>
                </vs-col>
                <vs-col class="px-2" vs-w="6">
                  <span class="text-uppercase custom-font-size-title">REDEMPTION</span>
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col class="px-2" vs-w="6">
                  <p
                    class="promotion-type font-medium truncate text-center"
                  >{{ tr.campaign_report.total_receive_message }}</p>
                </vs-col>
                <vs-col class="px-2" vs-w="6">
                  <p
                    class="promotion-type font-medium truncate text-center"
                  >{{ tr.campaign_report.total_redemption }}</p>
                </vs-col>
              </vs-row>
            </vs-td>
            <vs-td>
              <div @click.stop>
                <router-link
                  :to="{path: 'birthday/birthday-detail?id=' + tr.campaign.id, params: {birthdayInfo: tr}}"
                  :key="tr.id"
                >
                  <vs-button class="p-3 text-sm gradient gradient-primary no-shadow">See Detail</vs-button>
                </router-link>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <div v-if="birthdaysData._meta.pageCount">
      <!-- <vs-pagination class="custom-pagination" :total="parseInt(birthdaysData._meta.pageCount)" v-model="currentPage" @click.native="changePage(currentPage, itemsPerPage)"></vs-pagination> -->
      <custom-pagination
        class="custom-pagination mt-6"
        :totalPages="parseInt(birthdaysData._meta.pageCount)"
        :currentPage="currentPage"
        @pageChanged="changePage"
        :key="page_key"
      ></custom-pagination>
    </div>
    <vs-update-birth
      :currentPage="currentPage"
      :itemsPerPage="itemsPerPage"
      :updateBirthConfig="updateBirthConfig"
      :sidebarData="sidebarData"
      @UpdateBirthday="updateBirthday"
      @CloseUpdateBirth="closeUpdateBirth"
      :key="birth_day_key"
    ></vs-update-birth>
  </div>
  <div v-else-if="config.gocheckin_feature == 0">
    <vx-card>
      <h2>
        This is for Go Check In full version, please contact us for more info at
        <b>832-968-6668</b>
      </h2>
    </vx-card>
  </div>
  <custom-spinner v-else></custom-spinner>
</template>

<script>
// import modulePromoList from "@/store/promoList/index.js"
export default {
  // props: {
  //   dataChange: {
  //     type: Object
  //   }
  // },
  data() {
    return {
      selected: [],
      birthdayInfo: {},
      isMounted: false,
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {
        campaign: {},
        birthday_campaign: {},
        campaign_report: {}
      },
      updateBirthConfig: {
        isOpen: false
      },
      currentPage: 1,
      itemsPerPage: 10,
      items: [
        {
          title: "Home",
          url: "/",
          icon: "HomeIcon"
        },
        {
          title: "Birthday",
          active: true
        }
      ],
      action_type: "",
      isOpenLoading: false,
      page_key: 0,
      loaded_data_num: 0,
      birth_day_key: 0
    };
  },
  watch: {
  //   dataChange: {
  //     immediate: true,
  //     deep: true,
  //     handler: function () {
  //       // if(this.dataChange) {
  //       //   console.log(this.dataChange.message);
  //       // }
  //       // if(this.dataChange && this.dataChange.message == 'afterInsert') {
  //       if(this.dataChange) {
  //         const obj = {
  //           page: this.currentPage,
  //           "per-page": this.itemsPerPage,
  //         }
  //         this.$store.dispatch("promoList/GET_BIRTHDAY_LIST", obj)
  //       }
  //     },
  //   }
    loaded_data_num: {
      immediate: true,
      handler() {
        if(this.loaded_data_num >= 1) {
          this.closeLoading();
        } else {
          this.action_type = "Get data";
          this.openLoadingInDiv();
        }
      }
    },
    // config: {
    //   immediate: true,
    //   deep: true,
    //   handler() {
    //     if(this.config && this.config.gocheckin_feature != 0 && this.config.gocheckin_feature != 1) {
    //       this.action_type = "Get data";
    //       this.openLoadingInDiv();
    //     } else {
    //       this.closeLoading();
    //     }
    //   }
    // },
  },
  computed: {
    config() {
      return this.$store.getters["auth/config"];
    },
    birthdaysList() {
      return this.$store.state.promoList.birthdayList;
    },
    birthdaysData() {
      return this.$store.state.promoList.birthdayData;
    }
    // currentPage() {
    //   if(this.isMounted) {
    //     return this.$refs.table.currentx
    //   }
    //   return 0
    // },
    // serviceList() {
    //   return this.$store.state.serviceList
    // }
  },
  methods: {
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#app",
        scale: 0.8
      });
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout(() => {
        if (this.isOpenLoading) {
          this.closeLoading();
          // this.$vs.notify({
          //   title:'Notification',
          //   text: this.action_type + ' birthday failed',
          //   color:'danger',
          //   position:'top-right'})
          this.$vs.dialog({
            color: "danger",
            title: "Notification",
            text: this.action_type + " birthday failed",
            acceptText: "OK"
          });
        }
      }, 10000);
      // setTimeout( ()=> {
      //   this.$vs.loading.close('#staff-list > .con-vs-loading')
      // }, 500);
    },
    closeLoading() {
      this.$vs.loading.close("#app > .con-vs-loading");
      this.isOpenLoading = false;
    },
    changePage(currentPage) {
      const obj = {
        page: currentPage,
        "per-page": this.itemsPerPage
        // search: this.search
      };
      this.action_type = "Get list";
      if (!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.$store.dispatch("promoList/GET_BIRTHDAY_LIST", obj).then(() => {
        this.closeLoading();
        this.page_key++;
        this.currentPage = currentPage;
      });
    },
    updateBirthday(data) {
      // console.log(data)
      if (!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.action_type = "Update";
      this.$store.dispatch("promoList/UPDATE_BIRTHDAY", data).then(() => {
        this.closeLoading();
        this.$vs.notify({
          title: "Notification",
          text: "Update Birthday Success",
          color: "success",
          position: "top-right"
        });
      });
    },
    updateActiveBirthday(tr) {
      this.sidebarData = tr;
    },
    editData(data) {
      this.birth_day_key++;
      this.sidebarData = data;
      // this.sidebarData.info = data
      this.updateBirthConfig.isOpen = true;
    },
    closeUpdateBirth() {
      this.updateBirthConfig.isOpen = false;
      document.getElementById("birthday").click();
    }
  },
  created() {
    // if(!moduleDataList.isRegistered) {
    //   this.$store.registerModule('dataList', moduleDataList)
    //   moduleDataList.isRegistered = true
    // }
    // this.$store.dispatch("staffList/fetchDataListItems")
    const obj = {
      page: this.currentPage,
      "per-page": this.itemsPerPage
    };
    this.$store.dispatch("promoList/GET_BIRTHDAY_LIST", obj).then(() => {
      this.loaded_data_num++;
    });
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>
